import React from "react";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Card from "olive-react-myoneui/lib/Card";
import Button from "olive-react-myoneui/lib/Button";
import { useNavigate } from "react-router-dom";

function AvailableDates({courseSlug, className}) {
  const navigate = useNavigate();
  let host                      = window.location.protocol + '//' +window.location.host;
  const seeMoreDates = () => {
    navigate('/'+courseSlug);
    // window.location.replace(`${host}/${courseSlug}`);
  }
  return (
    <>
      <Container>
        <Card className={`${className || ''} available-dates-info border-0`}>
          <Card.Body>
            <Row className="align-items-center">
              <Col lg={8}>
                <h1>See available dates</h1>
                <p className="m-0">Training course detail page includes all the events.</p>
              </Col>
              <Col lg={4} className="text-end">
                <Button variant="outline" className="dark" onClick={seeMoreDates}>
                  See more dates
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}

export default AvailableDates;
